import Button from '../shared/button.jsx';

export default function NextButton(props) {
  return (
    <div className="next-button-container">
      <Button {...props} className="btn-small" />
    </div>
  );
}
